import(/* webpackMode: "eager" */ "/home/node/app/src/app/not-found.tsx");
